import React, { useState } from 'react';
import {
  FiHeadphones, FiPhone, FiMail, FiMessageCircle, FiSearch,
  FiChevronRight, FiChevronDown, FiArrowRight, FiCheck,
  FiClock, FiMapPin, FiStar, FiAlertCircle, FiCheckCircle,
  FiXCircle, FiRefreshCw, FiCreditCard, FiUser, FiX,
} from 'react-icons/fi';
import {
  MdOutlineLocalTaxi, MdOutlineSupportAgent, MdOutlineCancel,
  MdOutlinePayment, MdOutlineLocationOn, MdOutlineRateReview,
  MdOutlineReceiptLong, MdOutlineHelpOutline,
} from 'react-icons/md';
import {
  BsWhatsapp, BsChat, BsStarFill, BsQuestionCircle,
} from 'react-icons/bs';
import { RiCustomerService2Line, RiRefund2Line } from 'react-icons/ri';
import { HiOutlineLightningBolt } from 'react-icons/hi';
import { TbMessageChatbot, TbTicket } from 'react-icons/tb';
import logo from "../Assests/Jennifer Support page hero_FNL-wider.webp"

const RED       = '#e71204';
const RED2      = '#ff3a1f';
const LIGHT_RED = '#fff5f4';
const BORDER_RED= 'rgba(231,18,4,0.15)';

/* ─── DATA ───────────────────────────────────────────────────────────────────── */
const channels = [
  {
    Icon: FiPhone,
    color: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0',
    title: 'Call Us',
    value: '+91-6309376010',
    sub: 'Available 24 × 7, Toll Free',
    cta: 'Call Now',
    href: 'tel:6309376010',
  },
  {
    Icon: BsWhatsapp,
    color: '#25d366', bg: '#f0fdf4', border: '#bbf7d0',
    title: 'WhatsApp',
    value: '+91 63093 76010',
    sub: 'Chat with us instantly',
    cta: 'Open Chat',
    href: 'https://wa.me/916309376010',
  },
  {
    Icon: FiMail,
    color: '#2563eb', bg: '#eff6ff', border: '#bfdbfe',
    title: 'Email Support',
    value: 'supportbookinindia@gmail.com',
    sub: 'Reply within 2 business hours',
    cta: 'Send Email',
    href: 'mailto:supportbookinindia@gmail.com',
  },
  {
    Icon: TbMessageChatbot,
    color: RED, bg: LIGHT_RED, border: BORDER_RED,
    title: 'Live Chat',
    value: 'Chat in the App',
    sub: 'Instant replies, no waiting',
    cta: 'Start Chat',
    href: '#',
  },
];

const categories = [
  { Icon: MdOutlineLocalTaxi,    color: '#e71204', bg: LIGHT_RED,    border: BORDER_RED,  label: 'Booking Issues' },
  { Icon: MdOutlineCancel,       color: '#dc2626', bg: '#fef2f2',    border: '#fecaca',   label: 'Cancellations' },
  { Icon: RiRefund2Line,         color: '#7c3aed', bg: '#fdf4ff',    border: '#e9b8ff',   label: 'Refunds' },
  { Icon: MdOutlinePayment,      color: '#2563eb', bg: '#eff6ff',    border: '#bfdbfe',   label: 'Payments' },
  { Icon: MdOutlineLocationOn,   color: '#16a34a', bg: '#f0fdf4',    border: '#bbf7d0',   label: 'Live Tracking' },
  { Icon: MdOutlineRateReview,   color: '#d97706', bg: '#fffbf0',    border: '#fde68a',   label: 'Rate Your Ride' },
  { Icon: MdOutlineReceiptLong,  color: '#0891b2', bg: '#f0f9ff',    border: '#bae6fd',   label: 'Invoice / Bill' },
  { Icon: MdOutlineHelpOutline,  color: '#374151', bg: '#f9fafb',    border: '#e5e7eb',   label: 'Other Queries' },
];

const faqs = [
  {
    q: 'How do I cancel my BookinIndia ride?',
    a: 'Go to "My Bookings" in the app or website, select your booking, and tap "Cancel Ride". Cancellations made 1 hour before pickup are free. Late cancellations may attract a small fee as per our policy.',
  },
  {
    q: 'When will I receive my refund?',
    a: 'Refunds are processed within 5–7 business days to your original payment method. UPI refunds are typically faster (1–3 days). You will receive an email confirmation once the refund is initiated.',
  },
  {
    q: 'How do I change my pickup time or date?',
    a: 'Open "My Bookings", select your trip, and tap "Modify Booking". You can change the date, time, or pickup point up to 2 hours before the scheduled departure, subject to availability.',
  },
  {
    q: 'My driver is not responding. What should I do?',
    a: 'First, try calling the driver through the app. If there is no response within 5 minutes, tap "Report Issue" on the booking screen. Our team will reassign a driver or contact you with an update immediately.',
  },
  {
    q: 'Can I get an invoice for my trip?',
    a: 'Yes! After your trip is completed, go to "My Bookings" → select the trip → tap "Download Invoice". You can also request a GST invoice by emailing help@bookinindia.com with your booking ID.',
  },
  {
    q: 'Is my payment secure on BookinIndia?',
    a: 'Absolutely. BookinIndia uses PCI-DSS compliant payment gateways. We never store your card details. All transactions are encrypted with 256-bit SSL security.',
  },
];

const quickActions = [
  { Icon: TbTicket,       label: 'My Bookings',      color: '#e71204', bg: LIGHT_RED,  border: BORDER_RED },
  { Icon: RiRefund2Line,  label: 'Request Refund',   color: '#7c3aed', bg: '#fdf4ff',  border: '#e9b8ff' },
  { Icon: MdOutlineCancel,label: 'Cancel Ride',      color: '#dc2626', bg: '#fef2f2',  border: '#fecaca' },
  { Icon: MdOutlineReceiptLong, label: 'Get Invoice', color: '#2563eb', bg: '#eff6ff', border: '#bfdbfe' },
];

const stats = [
  { Icon: FiClock,               value: '< 2 min', label: 'Avg Response' },
  { Icon: RiCustomerService2Line, value: '24/7',    label: 'Support Hours' },
  { Icon: BsStarFill,            value: '4.9 ★',   label: 'Support Rating' },
  { Icon: FiCheckCircle,         value: '98%',      label: 'Issues Resolved' },
];

/* ─── FAQ ITEM ─────────────────────────────────────────────────────────────── */
const FAQItem = ({ item, index, isMobile }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{
      background: '#fff',
      border: `1.5px solid ${open ? RED : '#e5e7eb'}`,
      borderRadius: isMobile ? '16px' : '14px',
      overflow: 'hidden',
      transition: 'border-color 0.2s, box-shadow 0.2s',
      boxShadow: open ? `0 4px 20px ${BORDER_RED}` : '0 2px 8px rgba(0,0,0,0.04)',
      animation: `cardIn 0.4s ease both`,
      animationDelay: `${index * 0.06}s`,
    }}>
      <button onClick={() => setOpen(p => !p)} style={{
        width: '100%', display: 'flex',
        alignItems: 'center', justifyContent: 'space-between',
        padding: isMobile ? '16px 18px' : '18px 22px',
        background: 'none', border: 'none',
        cursor: 'pointer', textAlign: 'left', gap: '12px',
      }}>
        <span style={{
          fontSize: isMobile ? '14px' : '15px',
          fontWeight: 700, color: '#111827', lineHeight: 1.4, flex: 1,
        }}>
          {item.q}
        </span>
        <div style={{
          width: '28px', height: '28px', borderRadius: '50%',
          background: open ? LIGHT_RED : '#f4f5f9',
          border: `1px solid ${open ? BORDER_RED : '#e5e7eb'}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0, transition: 'all 0.2s',
        }}>
          <FiChevronDown style={{
            color: open ? RED : '#9ca3af', fontSize: '15px',
            transform: open ? 'rotate(180deg)' : 'rotate(0)',
            transition: 'transform 0.25s',
          }} />
        </div>
      </button>
      {open && (
        <div style={{ padding: isMobile ? '0 18px 16px' : '0 22px 18px', animation: 'expandIn 0.2s ease' }}>
          <div style={{ height: '1px', background: '#f0f0f0', marginBottom: '12px' }} />
          <p style={{
            fontSize: isMobile ? '13px' : '14px',
            color: '#4b5563', lineHeight: 1.7, margin: 0,
          }}>
            {item.a}
          </p>
        </div>
      )}
    </div>
  );
};

/* ─── CONTACT FORM ─────────────────────────────────────────────────────────── */
const ContactForm = ({ isMobile }) => {
  const [sent, setSent] = useState(false);
  const inputStyle = {
    width: '100%', border: '1.5px solid #e5e7eb',
    borderRadius: '12px', padding: '13px 16px',
    fontSize: '14px', color: '#111827',
    background: '#fafafa', outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    transition: 'border-color 0.2s',
  };
  return sent ? (
    <div style={{
      background: '#f0fdf4', border: '1.5px solid #bbf7d0',
      borderRadius: '16px', padding: '32px',
      textAlign: 'center',
    }}>
      <FiCheckCircle style={{ color: '#16a34a', fontSize: '40px', marginBottom: '12px' }} />
      <div style={{ fontSize: '17px', fontWeight: 800, color: '#15803d', marginBottom: '6px' }}>Message Sent!</div>
      <div style={{ fontSize: '13px', color: '#16a34a' }}>Our team will get back to you within 2 hours.</div>
    </div>
  ) : (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '12px' }}>
        <input style={inputStyle} placeholder="Your Name"
          onFocus={e => e.target.style.borderColor = RED}
          onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
        <input style={inputStyle} placeholder="Mobile Number"
          onFocus={e => e.target.style.borderColor = RED}
          onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
      </div>
      <input style={inputStyle} placeholder="Email Address"
        onFocus={e => e.target.style.borderColor = RED}
        onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
      <input style={inputStyle} placeholder="Booking ID (optional)"
        onFocus={e => e.target.style.borderColor = RED}
        onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
      <select style={{ ...inputStyle, cursor: 'pointer' }}>
        <option value="">Select Issue Type</option>
        <option>Booking Issue</option>
        <option>Cancellation</option>
        <option>Refund</option>
        <option>Payment</option>
        <option>Driver Complaint</option>
        <option>Invoice / Bill</option>
        <option>Other</option>
      </select>
      <textarea
        rows={4}
        placeholder="Describe your issue in detail..."
        style={{ ...inputStyle, resize: 'vertical', lineHeight: 1.6 }}
        onFocus={e => e.target.style.borderColor = RED}
        onBlur={e => e.target.style.borderColor = '#e5e7eb'}
      />
      <button
        onClick={() => setSent(true)}
        style={{
          background: `linear-gradient(135deg, ${RED}, ${RED2})`,
          color: '#fff', border: 'none',
          borderRadius: '12px', padding: '15px',
          fontSize: '15px', fontWeight: 800,
          cursor: 'pointer',
          boxShadow: `0 6px 20px rgba(231,18,4,0.3)`,
          display: 'flex', alignItems: 'center',
          justifyContent: 'center', gap: '7px',
          letterSpacing: '0.3px',
        }}>
        <FiHeadphones /> Submit Request
      </button>
    </div>
  );
};

/* ─── MAIN PAGE ─────────────────────────────────────────────────────────────── */
const SupportPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState(null);

  const filteredFAQs = faqs.filter(f =>
    searchQuery === '' ||
    f.q.toLowerCase().includes(searchQuery.toLowerCase()) ||
    f.a.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div style={{ fontFamily: "'Segoe UI', 'SF Pro Display', -apple-system, sans-serif" }}>

      {/* ════════════════════════════════ DESKTOP ════════════════════════════════ */}
      <div className="support-desktop">
        <div style={{ background: '#f4f5f9', minHeight: '100vh' }}>

          {/* Hero */}
          <div style={{
            background: '#fff',
            borderBottom: '1px solid #e5e7eb',
            padding: '64px 24px 56px',
            position: 'relative', overflow: 'hidden',
          }}>
            {/* <div style={{
              position: 'absolute', inset: 0,
              backgroundImage: 'radial-gradient(rgba(231,18,4,0.055) 1.5px, transparent 1.5px)',
              backgroundSize: '28px 28px', pointerEvents: 'none',
            }} />
            <div style={{
              position: 'absolute', top: '-80px', right: '6%',
              width: '360px', height: '360px', borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(231,18,4,0.07) 0%, transparent 70%)',
              pointerEvents: 'none',
            }} /> */}

            <div style={{ maxWidth: '1060px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '48px' }}>

                {/* Left */}
                <div style={{ flex: 1 }}>
                  <div style={{
                    display: 'inline-flex', alignItems: 'center', gap: '7px',
                    background: LIGHT_RED, border: `1px solid ${BORDER_RED}`,
                    borderRadius: '30px', padding: '7px 18px',
                    fontSize: '12px', fontWeight: 800, color: RED,
                    letterSpacing: '1.5px', marginBottom: '22px',
                  }}>
                    <RiCustomerService2Line size={15} /> SUPPORT CENTER
                  </div>

                  <h1 style={{
                    fontSize: '54px', fontWeight: 900,
                    color: '#111827', lineHeight: 1.05,
                    letterSpacing: '-2px', margin: '0 0 16px',
                  }}>
                    How Can We<br />
                    <span style={{ color: RED }}>Help You</span> Today?
                  </h1>

                  <p style={{
                    fontSize: '16px', color: '#6b7280',
                    maxWidth: '440px', lineHeight: 1.7,
                    margin: '0 0 28px',
                  }}>
                    Our dedicated support team is available 24×7. Search your issue, browse topics, or reach us directly.
                  </p>

                  {/* Search bar */}
                  <div style={{
                    display: 'flex', alignItems: 'center', gap: '12px',
                    background: '#f4f5f9',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '14px', padding: '4px 4px 4px 18px',
                    maxWidth: '500px',
                    transition: 'border-color 0.2s',
                  }}
                    onFocus={() => {}}
                  >
                    <FiSearch style={{ color: '#9ca3af', fontSize: '18px', flexShrink: 0 }} />
                    <input
                      value={searchQuery}
                      onChange={e => setSearchQuery(e.target.value)}
                      placeholder="Search for answers… e.g. cancel, refund, invoice"
                      style={{
                        flex: 1, border: 'none', outline: 'none',
                        background: 'transparent', fontSize: '14px',
                        color: '#111827', padding: '10px 0',
                        fontFamily: 'inherit',
                      }}
                    />
                    {searchQuery && (
                      <button onClick={() => setSearchQuery('')} style={{
                        background: 'none', border: 'none', cursor: 'pointer',
                        color: '#9ca3af', padding: '4px',
                      }}>
                        <FiX size={16} />
                      </button>
                    )}
                    <button style={{
                      background: `linear-gradient(135deg, ${RED}, ${RED2})`,
                      color: '#fff', border: 'none',
                      borderRadius: '10px', padding: '11px 20px',
                      fontSize: '13px', fontWeight: 700, cursor: 'pointer',
                      whiteSpace: 'nowrap',
                    }}>
                      Search
                    </button>
                  </div>
                </div>

                {/* Right — stats */}
              <div className='w-auto h-50 overflow-visible'>
  <img 
    src={logo} 
    alt='logo' 
    className='w-auto h-50 ml-40'
    style={{
      transform: 'scale(1.5)',  // Increases size by 50%
      transformOrigin: 'center center',
    }}
  />
</div>
              </div>
            </div>
          </div>

          <div style={{ maxWidth: '1060px', margin: '0 auto', padding: '48px 24px 80px' }}>

            {/* Contact Channels */}
            <div style={{ marginBottom: '56px' }}>
              <SectionHeader icon={<FiPhone style={{ color: RED }} />} title="Contact Us Directly" sub="Multiple ways to reach our support team instantly" />
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
                {channels.map((ch, i) => {
                  const { Icon } = ch;
                  return (
                    <a key={ch.title} href={ch.href} style={{ textDecoration: 'none' }}>
                      <div style={{
                        background: '#fff', border: '1.5px solid #e5e7eb',
                        borderRadius: '20px', padding: '24px',
                        display: 'flex', flexDirection: 'column', gap: '14px',
                        boxShadow: '0 4px 14px rgba(0,0,0,0.05)',
                        transition: 'transform 0.25s, box-shadow 0.25s, border-color 0.2s',
                        cursor: 'pointer',
                        animation: `cardIn 0.45s ease both`,
                        animationDelay: `${i * 0.07}s`,
                      }}
                        onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 16px 40px rgba(0,0,0,0.1)'; e.currentTarget.style.borderColor = ch.color; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.05)'; e.currentTarget.style.borderColor = '#e5e7eb'; }}
                      >
                        <div style={{
                          width: '50px', height: '50px', borderRadius: '15px',
                          background: ch.bg, border: `1.5px solid ${ch.border}`,
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                          <Icon style={{ color: ch.color, fontSize: '22px' }} />
                        </div>
                        <div>
                          <div style={{ fontSize: '11px', fontWeight: 700, color: '#9ca3af', letterSpacing: '1px', marginBottom: '4px' }}>{ch.title}</div>
                          <div style={{ fontSize: '15px', fontWeight: 800, color: '#111827', marginBottom: '3px' }}>{ch.value}</div>
                          <div style={{ fontSize: '12px', color: '#9ca3af' }}>{ch.sub}</div>
                        </div>
                        <div style={{
                          display: 'inline-flex', alignItems: 'center', gap: '5px',
                          color: ch.color, fontSize: '13px', fontWeight: 700,
                          marginTop: 'auto',
                        }}>
                          {ch.cta} <FiArrowRight size={13} />
                        </div>
                      </div>
                    </a>
                  );
                })}
              </div>
            </div>

            {/* Browse by Category */}
            <div style={{ marginBottom: '56px' }}>
              <SectionHeader icon={<MdOutlineHelpOutline style={{ color: RED }} />} title="Browse by Topic" sub="Select a category to find the right help quickly" />
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' }}>
                {categories.map((cat, i) => {
                  const { Icon } = cat;
                  const active = activeCategory === cat.label;
                  return (
                    <button key={cat.label} onClick={() => setActiveCategory(active ? null : cat.label)} style={{
                      background: active ? cat.bg : '#fff',
                      border: `1.5px solid ${active ? cat.color : '#e5e7eb'}`,
                      borderRadius: '14px', padding: '18px 16px',
                      display: 'flex', alignItems: 'center', gap: '12px',
                      cursor: 'pointer', textAlign: 'left',
                      transition: 'all 0.2s',
                      boxShadow: active ? `0 4px 16px ${cat.color}22` : '0 2px 8px rgba(0,0,0,0.04)',
                      animation: `cardIn 0.4s ease both`,
                      animationDelay: `${i * 0.05}s`,
                    }}
                      onMouseEnter={e => { if (!active) { e.currentTarget.style.borderColor = cat.color; e.currentTarget.style.background = cat.bg; } }}
                      onMouseLeave={e => { if (!active) { e.currentTarget.style.borderColor = '#e5e7eb'; e.currentTarget.style.background = '#fff'; } }}
                    >
                      <div style={{
                        width: '38px', height: '38px', borderRadius: '11px',
                        background: active ? '#fff' : cat.bg,
                        border: `1px solid ${cat.border}`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}>
                        <Icon style={{ color: cat.color, fontSize: '18px' }} />
                      </div>
                      <span style={{ fontSize: '13px', fontWeight: 700, color: active ? cat.color : '#374151' }}>{cat.label}</span>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* FAQ + Contact Form side by side */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>

              {/* FAQs */}
              <div>
                <SectionHeader icon={<BsQuestionCircle style={{ color: RED }} />} title="Frequently Asked" sub="Quick answers to common questions" small />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {filteredFAQs.length > 0
                    ? filteredFAQs.map((f, i) => <FAQItem key={f.q} item={f} index={i} isMobile={false} />)
                    : (
                      <div style={{
                        background: '#fff', border: '1.5px solid #e5e7eb',
                        borderRadius: '14px', padding: '32px', textAlign: 'center',
                      }}>
                        <FiAlertCircle style={{ color: '#9ca3af', fontSize: '32px', marginBottom: '10px' }} />
                        <div style={{ fontSize: '14px', color: '#9ca3af', fontWeight: 600 }}>No results for "{searchQuery}"</div>
                        <div style={{ fontSize: '12px', color: '#d1d5db', marginTop: '4px' }}>Try a different keyword or contact us directly.</div>
                      </div>
                    )
                  }
                </div>
              </div>

              {/* Contact Form */}
              <div>
                <SectionHeader icon={<FiMail style={{ color: RED }} />} title="Send a Request" sub="Our team replies within 2 business hours" small />
                <div style={{
                  background: '#fff', border: '1.5px solid #e5e7eb',
                  borderRadius: '20px', padding: '28px',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.05)',
                }}>
                  <ContactForm isMobile={false} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════ MOBILE ════════════════════════════════ */}
      <div className="support-mobile">
        <div style={{
          background: '#f4f5f9', minHeight: '100vh',
          maxWidth: '430px',
          fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
          paddingBottom: '110px',
          marginTop:'-100px',

        }}>

          {/* App Header */}
          <div style={{
            background: '#fff', borderBottom: '1px solid #f0f0f0',
            padding: '52px 18px 22px',
            position: 'relative', overflow: 'hidden',

            
          }}>
            <div style={{
                
              position: 'absolute', top: '-30px', right: '-30px',
              width: '140px', height: '140px', borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(231,18,4,0.07), transparent 70%)',
            }} />
            <div style={{
                
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              background: LIGHT_RED, border: `1px solid ${BORDER_RED}`,
              borderRadius: '20px', padding: '5px 14px',
              fontSize: '11px', fontWeight: 800, color: RED,
              letterSpacing: '1px', marginBottom: '12px',
            }}>
              <RiCustomerService2Line size={13} /> SUPPORT CENTER
            </div>
            <h1 style={{
              fontSize: '27px', fontWeight: 900, color: '#111827',
              lineHeight: 1.15, letterSpacing: '-0.8px', margin: '0 0 10px',
            }}>
              How Can We<br /><span style={{ color: RED }}>Help You</span> Today?
            </h1>
            <p style={{ fontSize: '13px', color: '#9ca3af', margin: '0 0 18px', lineHeight: 1.5 }}>
              24×7 support — search, browse topics, or reach us directly.
            </p>

            {/* Mobile search */}
            <div style={{
              display: 'flex', alignItems: 'center', gap: '10px',
              background: '#f4f5f9', border: '1.5px solid #e5e7eb',
              borderRadius: '13px', padding: '11px 14px',
            }}>
              <FiSearch style={{ color: '#9ca3af', fontSize: '16px', flexShrink: 0 }} />
              <input
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                placeholder="Search for help…"
                style={{
                  flex: 1, border: 'none', outline: 'none',
                  background: 'transparent', fontSize: '14px',
                  color: '#111827', fontFamily: 'inherit',
                }}
              />
              {searchQuery && (
                <button onClick={() => setSearchQuery('')} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                  <FiX size={15} style={{ color: '#9ca3af' }} />
                </button>
              )}
            </div>
             <div className='w-auto h-50 overflow-visible'>
  <img 
    src={logo} 
    alt='logo' 
    className='w-auto h-50 '
    style={{
      transform: 'scale(1.0)',  // Increases size by 50%
      transformOrigin: 'center center',
    }}
  />
</div>
          </div>

          {/* Stats row */}
          <div style={{ padding: '14px 18px 0', display: 'flex', gap: '10px', overflowX: 'auto' }}>
          
          </div>

          {/* Quick Actions */}
          <div style={{ padding: '18px 18px 0' }}>
            <div style={{ fontSize: '16px', fontWeight: 800, color: '#111827', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <HiOutlineLightningBolt style={{ color: RED }} /> Quick Actions
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              {quickActions.map(({ Icon, label, color, bg, border }) => (
                <button key={label} style={{
                  background: '#fff', border: `1px solid #e5e7eb`,
                  borderRadius: '14px', padding: '14px',
                  display: 'flex', alignItems: 'center', gap: '10px',
                  cursor: 'pointer', textAlign: 'left',
                  transition: 'all 0.2s',
                }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = color; e.currentTarget.style.background = bg; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = '#e5e7eb'; e.currentTarget.style.background = '#fff'; }}
                >
                  <div style={{
                    width: '36px', height: '36px', borderRadius: '11px',
                    background: bg, border: `1px solid ${border}`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                  }}>
                    <Icon style={{ color, fontSize: '18px' }} />
                  </div>
                  <span style={{ fontSize: '12.5px', fontWeight: 700, color: '#374151', lineHeight: 1.3 }}>{label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Contact Channels */}
          <div style={{ padding: '20px 18px 0' }}>
            <div style={{ fontSize: '16px', fontWeight: 800, color: '#111827', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <FiPhone style={{ color: RED }} /> Contact Us
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {channels.map((ch) => {
                const { Icon } = ch;
                return (
                  <a key={ch.title} href={ch.href} style={{ textDecoration: 'none' }}>
                    <div style={{
                      background: '#fff', borderRadius: '16px',
                      border: '1px solid #e5e7eb',
                      padding: '16px 18px',
                      display: 'flex', alignItems: 'center', gap: '14px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                      transition: 'all 0.2s',
                    }}
                      onMouseEnter={e => { e.currentTarget.style.borderColor = ch.color; }}
                      onMouseLeave={e => { e.currentTarget.style.borderColor = '#e5e7eb'; }}
                    >
                      <div style={{
                        width: '44px', height: '44px', borderRadius: '14px',
                        background: ch.bg, border: `1px solid ${ch.border}`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}>
                        <Icon style={{ color: ch.color, fontSize: '20px' }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '11px', color: '#9ca3af', fontWeight: 700, letterSpacing: '0.5px' }}>{ch.title}</div>
                        <div style={{ fontSize: '14px', fontWeight: 800, color: '#111827' }}>{ch.value}</div>
                        <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '1px' }}>{ch.sub}</div>
                      </div>
                      <FiChevronRight style={{ color: '#9ca3af', fontSize: '18px', flexShrink: 0 }} />
                    </div>
                  </a>
                );
              })}
            </div>
          </div>

          {/* Browse Topics */}
          <div style={{ padding: '20px 18px 0' }}>
            <div style={{ fontSize: '16px', fontWeight: 800, color: '#111827', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <MdOutlineHelpOutline style={{ color: RED }} /> Browse Topics
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '9px' }}>
              {categories.map(({ Icon, label, color, bg, border }) => (
                <button key={label} style={{
                  background: '#fff', border: `1px solid #e5e7eb`,
                  borderRadius: '13px', padding: '13px 14px',
                  display: 'flex', alignItems: 'center', gap: '9px',
                  cursor: 'pointer', textAlign: 'left',
                  transition: 'all 0.15s',
                }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = color; e.currentTarget.style.background = bg; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = '#e5e7eb'; e.currentTarget.style.background = '#fff'; }}
                >
                  <div style={{
                    width: '32px', height: '32px', borderRadius: '9px',
                    background: bg, border: `1px solid ${border}`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                  }}>
                    <Icon style={{ color, fontSize: '16px' }} />
                  </div>
                  <span style={{ fontSize: '12px', fontWeight: 700, color: '#374151' }}>{label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* FAQ */}
          <div style={{ padding: '20px 18px 0' }}>
            <div style={{ fontSize: '16px', fontWeight: 800, color: '#111827', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <BsQuestionCircle style={{ color: RED }} /> FAQs
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
              {filteredFAQs.length > 0
                ? filteredFAQs.map((f, i) => <FAQItem key={f.q} item={f} index={i} isMobile={true} />)
                : (
                  <div style={{
                    background: '#fff', borderRadius: '16px',
                    border: '1px solid #e5e7eb', padding: '24px', textAlign: 'center',
                  }}>
                    <FiAlertCircle style={{ color: '#d1d5db', fontSize: '28px', marginBottom: '8px' }} />
                    <div style={{ fontSize: '13px', color: '#9ca3af', fontWeight: 600 }}>No results for "{searchQuery}"</div>
                  </div>
                )}
            </div>
          </div>

          {/* Contact Form */}
          <div style={{ padding: '20px 18px 0' }}>
            <div style={{ fontSize: '16px', fontWeight: 800, color: '#111827', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <FiMail style={{ color: RED }} /> Send a Request
            </div>
            <div style={{
              background: '#fff', borderRadius: '20px',
              border: '1px solid #e5e7eb', padding: '20px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
            }}>
              <ContactForm isMobile={true} />
            </div>
          </div>

          {/* Fixed bottom bar */}
          <div style={{
            position: 'fixed', bottom: 0,
            left: '50%', transform: 'translateX(-50%)',
            width: '100%', maxWidth: '430px',
            padding: '12px 18px 28px',
            background: 'rgba(255,255,255,0.97)',
            backdropFilter: 'blur(12px)',
            borderTop: '1px solid #f0f0f0',
            zIndex: 200,
            display: 'flex', gap: '10px',
          }}>
            <a href="tel:1800XXXXXXX" style={{ flex: 1, textDecoration: 'none' }}>
              <button style={{
                width: '100%',
                background: '#fff',
                color: RED, border: `1.5px solid ${BORDER_RED}`,
                borderRadius: '14px', padding: '15px',
                fontSize: '14px', fontWeight: 800,
                cursor: 'pointer',
                display: 'flex', alignItems: 'center',
                justifyContent: 'center', gap: '7px',
              }}>
                <FiPhone /> Call Support
              </button>
            </a>
            <button style={{
              flex: 1,
              background: `linear-gradient(135deg, ${RED}, ${RED2})`,
              color: '#fff', border: 'none',
              borderRadius: '14px', padding: '15px',
              fontSize: '14px', fontWeight: 800,
              cursor: 'pointer',
              boxShadow: `0 5px 18px rgba(231,18,4,0.35)`,
              display: 'flex', alignItems: 'center',
              justifyContent: 'center', gap: '7px',
            }}>
              <BsWhatsapp /> WhatsApp
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .support-desktop { display: block; }
        .support-mobile  { display: none;  }

        @media (max-width: 767px) {
          .support-desktop { display: none !important;  }
          .support-mobile  { display: block !important; }
        }

        @keyframes cardIn {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0);    }
        }
        @keyframes expandIn {
          from { opacity: 0; transform: translateY(-6px); }
          to   { opacity: 1; transform: translateY(0);    }
        }

        input::placeholder, textarea::placeholder { color: #9ca3af; }
        ::-webkit-scrollbar { height: 4px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: #e5e7eb; border-radius: 4px; }
      `}</style>
    </div>
  );
};

/* ─── SECTION HEADER HELPER ─────────────────────────────────────────────────── */
const SectionHeader = ({ icon, title, sub, small }) => (
  <div style={{ marginBottom: '20px' }}>
    <h2 style={{
      fontSize: small ? '20px' : '26px',
      fontWeight: 900, color: '#111827',
      margin: '0 0 6px', letterSpacing: '-0.5px',
      display: 'flex', alignItems: 'center', gap: '8px',
    }}>
      {icon} {title}
    </h2>
    {sub && <p style={{ fontSize: '14px', color: '#9ca3af', margin: 0 }}>{sub}</p>}
  </div>
);

export default SupportPage;